<template>
  <div class="chart-container">
    <div :id="chartId"></div>
  </div>
</template>

<script>
import CanvasJS from '@canvasjs/charts';

export default {
  name: 'BaseChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      chart: null,
      chartId: `chart-${this._uid}`
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          if (this.chart) {
            this.createChart();
          }
        });
      }
    }
  },
  mounted () {
    this.createChart();
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    createChart () {
      this.chart = new CanvasJS.Chart(this.chartId, {
        animationEnabled: true,
        theme: 'light2',
        culture: 'fr',
        backgroundColor: null,
        ...this.chartOptions
      });

      this.chart.render();
    }
  }
};
</script>

<style>
.canvasjs-chart-credit {
  display: none;
}
</style>
